import { Button, Modal } from "react-bootstrap";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { useEffect, useRef, useState } from "react";
import { base64StringtoFile } from "../Base64Image/ConvertBase64ToFile";

interface CropImageProps {
    imageFile: File | null;
    showCropModal: boolean;
    setShowCropModal: (val: boolean) => void;
    onImageCropped: (file: File) => void;
}

export const CropProfileImage: React.FC<CropImageProps> = ({
    imageFile,
    showCropModal,
    setShowCropModal,
    onImageCropped,
}) => {
    const [image, setImage] = useState("");
    const cropperRef = useRef<ReactCropperElement>(null);

    useEffect(() => {
        if (!imageFile) {
            setImage("");
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result as string);
        };
        reader.readAsDataURL(imageFile);
    }, [imageFile]);

    const HandleCropClick = () => {
        const croppedDataUrl = cropperRef.current?.cropper.getCroppedCanvas().toDataURL();
        const croppedFile = base64StringtoFile(croppedDataUrl, imageFile?.name ?? "CroppedImage");

        if (croppedFile) {
            onImageCropped(croppedFile);
        }

        setShowCropModal(false);
    };

    return (
        <>
            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={showCropModal} animation={true}>
                <Modal.Body>
                    <div className="mt-3">
                        <div style={{ width: "100%" }}>
                            <Cropper
                                initialAspectRatio={1}
                                src={image}
                                ref={cropperRef}
                                viewMode={3}
                                guides={true}
                                minCropBoxHeight={10}
                                minCropBoxWidth={10}
                                background={false}
                                responsive={true}
                                checkOrientation={false}
                                aspectRatio={1}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={HandleCropClick}>
                        Crop
                    </Button>
                    <Button variant="primary" onClick={() => { setShowCropModal(false) }}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
